export const LANDSCAPE_VARIATIONS = [
  { id: 'social_link', label: 'Campaign', channel: 'partner_message' },
  { id: 'website_press', label: 'Website / press', channel: 'press_release' },
];

// Keep the original keys so existing drafts and layout presets remain editable.
export const landscapeVariation = (config = {}) => {
  if (LANDSCAPE_VARIATIONS.some(({ id }) => id === config.landscape_variation)) {
    return config.landscape_variation;
  }
  return !config.asset_copy?.social_link && config.asset_copy?.website_press
    ? 'website_press'
    : 'social_link';
};

export const mediaAssetCopyId = (config, assetId) => (
  assetId === 'social_link' ? landscapeVariation(config) : assetId
);

export const mediaAssetConfig = (config = {}, assetId) => {
  const copyId = mediaAssetCopyId(config, assetId);
  const copy = config.asset_copy?.[copyId];
  const fallback = assetId === 'social_link'
    ? config.asset_copy?.[copyId === 'social_link' ? 'website_press' : 'social_link']
    : null;
  return { ...config, ...(copy || fallback || {}) };
};
